/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerUpLeftDouble = createReactComponent(
  "corner-up-left-double",
  "IconCornerUpLeftDouble",
  [
    ["path", { d: "M19 18v-6a3 3 0 0 0 -3 -3h-7", key: "svg-0" }],
    ["path", { d: "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4", key: "svg-1" }]
  ]
);

export { IconCornerUpLeftDouble as default };
//# sourceMappingURL=IconCornerUpLeftDouble.js.map
